import React from "react";

function Home() {
    return <div>this is home</div>
}

export default Home;